import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
// Theme-wise styles applied across permissions
